import React, { useEffect, useState } from "react";
import {
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  useDisclosure,
  Button,
  Box,
  FormLabel,
  Stack,
  Input,
  Select,
  useToast,
  MenuItem,
  Progress,
  Flex,
} from "@chakra-ui/react";
import { storage, getFirestoreApp } from "../firebase-config";
import {
  collection,
  addDoc,
  serverTimestamp,
  updateDoc,
  doc,
  getDoc,
} from "firebase/firestore";
import { getDownloadURL, ref, uploadBytesResumable } from "firebase/storage";
import { useParams } from "react-router-dom";
import { BsFillPersonPlusFill } from "react-icons/bs";
import { DownloadIcon, EditIcon } from "@chakra-ui/icons";

const initialState = {
  nome: "",
  cnh: "",
  cnh_categoria: "",
  cnh_validade: "",
  cnh_image: "",
};

const AddEditMotorista = ({ getMotoristas, setLoading, motoristaId }) => {
  const [isDisabled, setIsDisabled] = useState(false); // Desabilitar botão após submit para evitar duplicação
  const db = getFirestoreApp;
  const { isOpen, onOpen, onClose } = useDisclosure();
  const firstField = React.useRef();
  const toast = useToast();

  const [addData, AddSetData] = useState(initialState);
  const { nome, cnh, cnh_categoria, cnh_validade } = addData;
  const [file, setFile] = useState(null);
  const [progress, setProgress] = useState(null);
  const [error, setError] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);
  const [pushdata, SetPushData] = useState(true);

  const { carroId, filialId } = useParams();

  useEffect(() => {
    carroId, filialId;
  }, [carroId, filialId]);

  const handleChange = (e) => {
    AddSetData({
      ...addData,
      [e.target.name]: e.target.value,
    });
  };

  const addMotorista = async (e) => {
    setIsDisabled(true);
    e.preventDefault();
    setIsSubmit(true);
    const docRef = await addDoc(
      collection(
        db,
        "/FILIAIS/91IYpjJbXYN99Asq2Enw",
        filialId,
        carroId,
        "Motoristas"
      ),
      {
        ...addData,
        created_at: serverTimestamp(),
      }
    );
    if (file) {
      const storageRef = ref(storage, `CNHS/${docRef.id}`);
      const uploadTask = uploadBytesResumable(storageRef, file);
      uploadTask.on(
        "state_changed",
        (snapshot) => {
          const progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          setProgress(progress);
          console.log("Upload is " + progress + "% done");

          switch (snapshot.state) {
            case "paused":
              console.log("Upload is paused");
              break;
            default:
              break;
          }
        },
        (error) => {
          console.log(error);
        },
        async () => {
          await getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
            updateDoc(docRef, {
              cnh_image: downloadURL,
            });
          });
        }
      );
    }
    setLoading(true);

    setTimeout(() => {
      onClose();
      ToastMotoristaAdd();
      getMotoristas();
      setLoading(false);
      handleReset();
      setIsDisabled(false);
    }, 2300);
  };

  const editMotorista = async (e) => {
    setIsDisabled(true);
    const docRef = doc(
      db,
      "/FILIAIS/91IYpjJbXYN99Asq2Enw/",
      filialId,
      carroId,
      "Motoristas",
      motoristaId
    );

    e.preventDefault();
    setIsSubmit(true);
    await updateDoc(docRef, {
      ...addData,
    });

    setLoading(true);

    setTimeout(() => {
      onClose();
      ToastMotoristaEdit();
      getMotoristas();
      setLoading(false);
      handleReset();
      setIsDisabled(false);
    }, 2100);
  };

  const handleReset = () => {
    setTimeout(() => {
      AddSetData(initialState);
    }, 1000);
  };

  const ToastMotoristaAdd = () => {
    return toast({
      title: "Motorista adcionado com sucesso!",
      position: "bottom",
      status: "success",
      variant: "top-accent",
      duration: 3000,
      isClosable: true,
    });
  };

  const ToastMotoristaEdit = () => {
    return toast({
      title: "Motorista atualizado com sucesso!",
      position: "bottom",
      status: "success",
      variant: "top-accent",
      duration: 3000,
      isClosable: true,
    });
  };

  const GetOneMotorista = async () => {
    const docRef = doc(
      db,
      "/FILIAIS/91IYpjJbXYN99Asq2Enw/",
      filialId,
      carroId,
      "Motoristas",
      motoristaId
    );
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      AddSetData({ ...docSnap.data(), update_at: serverTimestamp() });
      SetPushData(false);
    } else {
    }
  };

  return (
    <>
      {motoristaId ? (
        <MenuItem
          icon={<EditIcon />}
          variant="ghost"
          onClick={onOpen}
          width="100%"
        >
          Editar Motorista
        </MenuItem>
      ) : (
        <Button
          mt={-6}
          mb={2}
          leftIcon={<BsFillPersonPlusFill />}
          variant="ghost"
          onClick={onOpen}
        >
          Adicionar Motorista
        </Button>
      )}

      <Drawer
        isOpen={isOpen}
        size="sm"
        placement="bottom"
        initialFocusRef={firstField}
        onClose={onClose}
      >
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader borderBottomWidth="1px">
            {motoristaId ? "EDITAR MOTORISTA:" : "ADCIONAR NOVO MOTORISTA:"}
          </DrawerHeader>

          <DrawerBody>
            <Stack spacing="24px">
              <Box>
                <FormLabel htmlFor="nome">Nome motorista:</FormLabel>
                <Input
                  id="nome"
                  name="nome"
                  placeholder="Ex: Israel França"
                  variant="filled"
                  value={nome}
                  onChange={handleChange}
                />
              </Box>

              <Box>
                <FormLabel htmlFor="cnh">Número CNH:</FormLabel>
                <Input
                  id="cnh"
                  name="cnh"
                  placeholder="Ex: 0002579814"
                  variant="filled"
                  value={cnh}
                  onChange={handleChange}
                />
              </Box>

              <Box>
                <FormLabel htmlFor="cnh_categoria">Categoria:</FormLabel>
                <Select
                  id="cnh_categoria"
                  name="cnh_categoria"
                  variant="filled"
                  value={cnh_categoria}
                  onChange={handleChange}
                >
                  <option value="">-</option>
                  <option value="B">B</option>
                  <option value="A/B">A/B</option>
                  <option value="B/C">B/C</option>
                  <option value="A/B/C">A/B/C</option>
                  <option value="A/D">A/D</option>
                </Select>
              </Box>
              <Box>
                {/* <FormLabel htmlFor="cnh_validade">Validade:</FormLabel>
                <Input
                  id="cnh_validade"
                  name="cnh_validade"
                  placeholder="Ex: 2010"
                  variant="filled"
                  value={cnh_validade}
                  onChange={handleChange}
                /> */}
                <FormLabel htmlFor="cnh_validade">Validade:</FormLabel>
                <Input
                  type="date"
                  name="cnh_validade"
                  id="cnh_validade"
                  placeholder="Ex: 2025"
                  variant="filled"
                  value={cnh_validade}
                  onChange={handleChange}
                ></Input>
              </Box>

              {motoristaId ? null : (
                <Box py={50}>
                  <FormLabel htmlFor="cnh_image">Foto CNH:</FormLabel>
                  <Input
                    type="file"
                    accept="image/*"
                    onChange={(e) => {
                      const file = e.target.files[0];
                      if (file) {
                        if (file.type.startsWith("image/")) {
                          setFile(file);
                        } else {
                          toast({
                            title:
                              "Tipo de arquivo inválido, permitido apenas imagens!",
                            status: "error",
                            duration: 5000,
                            isClosable: true,
                            position: "top",
                          });
                          setFile(null);
                        }
                      } else {
                        setFile(null);
                      }
                    }}
                  />
                </Box>
              )}
            </Stack>
            <Flex justifyContent={"center"} pt={3}>
              {motoristaId ? (
                pushdata ? (
                  <Button
                    leftIcon={<DownloadIcon />}
                    colorScheme="green"
                    onClick={GetOneMotorista}
                    size="sm"
                    variant="outline"
                  >
                    Preencher com dados existentes
                  </Button>
                ) : null
              ) : null}
            </Flex>
          </DrawerBody>

          <DrawerFooter borderTopWidth="1px">
            <Button variant="outline" mr={3} onClick={onClose}>
              SAIR
            </Button>

            {motoristaId ? (
              <Button
                px={10}
                colorScheme="blue"
                onClick={editMotorista}
                type="submit"
                disabled={progress !== null && progress < 100 && isDisabled}
              >
                ATUALIZAR
              </Button>
            ) : (
              <Button
                colorScheme="green"
                type="submit"
                onClick={addMotorista}
                isDisabled={
                  !file ||
                  isDisabled ||
                  (file && !file.type.startsWith("image/"))
                }
              >
                Cadastrar
              </Button>
            )}
          </DrawerFooter>
          {progress !== null && progress < 100 ? (
            <Progress colorScheme="green" size="lg" value={progress} />
          ) : null}
        </DrawerContent>
      </Drawer>
    </>
  );
};

export default AddEditMotorista;
